export const PROJECT_TAB_LIST = [
  {
    id: 4,
    title: "Tổng quan",
    to: `/projects/dashboard`,
  },
  {
    id: 0,
    title: "List",
    to: `/projects/task-table`,
  },
  {
    id: 3,
    title: "Kanban",
    to: `/projects/task-kanban`,
  },
  {
    id: 2,
    title: "Gantt",
    to: `/projects/task-gantt`,
  },
  {
    id: 1,
    title: "Chat",
    to: `/projects/task-chat`,
  },
  {
    id: 5,
    title: "Báo cáo",
    to: `/projects/report`,
  },
];